export const embedChatTeachingCalloutTitle = "cwPYKd";
export const embedChatTeachingCalloutDesc = "h6vRmd";
export const embedChatcalloutPrimaryButtonText = "OhoyEd";
export const embedChatcalloutSecondaryButtonText = "GEjRnb";
export default {embedChatTeachingCalloutTitle,embedChatTeachingCalloutDesc,embedChatcalloutPrimaryButtonText,embedChatcalloutSecondaryButtonText};